export default "__VITE_ASSET__DiwM1Iyb__"